module.exports = __webpack_public_path__ + "static/desktop/img/album-bg.e078cad2.png";